import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
/**
 * Feature flag route guard — pairs with the backend `feature(key)` dependency.
 *
 * When the flag is OFF (or unknown) for the caller's tenant, redirect to the
 * fallback route. When ON, render children. Mirrors the existence-not-
 * disclosed semantics of the backend (404 there, redirect here) so a tenant
 * without the feature does not see the route at all.
 *
 *   <FeatureGate flag="phase2_vendor_rfq">
 *     <VendorHomePage />
 *   </FeatureGate>
 */
export function FeatureGate({ flag, anyOf, children, fallback = '/access-denied' }) {
    const me = useAuthStore((s) => s.me);
    const location = useLocation();
    if (!me) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location.pathname } });
    }
    const keys = anyOf ?? (flag ? [flag] : []);
    const enabled = keys.some((k) => !!me.feature_flags?.[k]);
    if (!enabled) {
        return (_jsx(Navigate, { to: fallback, replace: true, state: { from: location.pathname, requiredFeature: keys.join('|') } }));
    }
    return _jsx(_Fragment, { children: children });
}
